import '/Users/ghengeveld/Development/Chromatic/addon-visual-tests/dist/manager.mjs';